import styles from './Step.module.scss'
import { Button } from '@/ui'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { verificationThunks } from '@/entity/verification'
import { LoadingBlocker } from '@/components/Loader'

export const Step2 = () => {
	const dispatch = useDispatch()
	const { t } = useTranslation()

	const {phone, iin, send_sms} = useSelector(state => ({
		phone: state.verification.phone,
		iin: state.verification.iin,
		send_sms: state.verification.send_sms,
	}))

	const getPhone = () => {
		dispatch(verificationThunks.sendPhoneForIin({ iin: iin.data?.iin }))
	}

	return (
		<>
			<div className={styles.sms_text}>
				{t('tel_bmg')}
				<div className={styles.tel}>{phone.data?.phone}</div>
				{t('send_sms')}
				<div className={styles.button_send}>
					<Button type="button" onClick={getPhone}>
						{t('send')}
					</Button>
				</div>
			</div>

			{send_sms.loading && <LoadingBlocker />}
		</>
	)
}